export default "__VITE_ASSET__tO83OFhI__"